<template>
  <div class="wrap2">
    <div
      :class="[
        'my-package-container',
        not_iphonex ? 'notrem-my-package-container-notiphonex' : '',
        iphonex && !not_iphonex ? 'notrem-my-package-container-iphonex' : '',
      ]"
    >
      <van-nav-bar title="我的快递" left-arrow @click-left="goBack" />
      <div class="my-package-container-list">
        <van-tabs v-model="initialPage">
          <van-tab title="全部" :name="0">
            <listView :status="0"></listView>
          </van-tab>
          <van-tab title="待发货" :name="1">
            <listView :status="1"></listView>
          </van-tab>
          <van-tab title="待收货" :name="2">
            <listView :status="2"></listView>
          </van-tab>
          <van-tab title="已签收" :name="3">
            <listView :status="3"></listView>
          </van-tab>
          <van-tab title="退换" :name="10">
            <listView :status="10"></listView>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import listView from "./components/listView";
import appUtil from "../../utils/appUtil";
export default {
  name: "package",
  data() {
    return {
      initialPage: 0,
      not_iphonex: window.navigator.userAgent.includes("not_iphonex"),
      iphonex: window.navigator.userAgent.includes("iphonex"),
    };
  },
  components: {
    listView,
  },
  created() {},
  mounted() {
    let isApp = new appUtil().isApp();
    if (isApp == "android" || isApp == "ios") {
      window.dhsdk.isShowNavigation({
        show: false,
      });
    }
    this.initTabPage();
  },
  methods: {
    initTabPage() {
      let query = location.hash.split("?")[1];
      if (query) {
        var vars = query.split("&");
        let tab = -1;
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == "tab") {
            tab = pair[1];
          }
        }
        if (tab >= 0) {
          this.initialPage = Number(tab);
        }
      }
    },
    goBack() {
      window.dhsdk.finishInterface();
    },
  },
};
</script>
<style lang="scss" scoped>
.my-package-container-list {
  height: 100%;
  font-size: 14px;
}
.wrap2 {
  overflow: scroll;
  background-color: #fff;
  height: 100%;
}
.my-package-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f4f4f4;

  .van-nav-bar .van-icon {
    color: initial;
  }
  .van-hairline--bottom::after {
    border: none;
  }
}
.notrem-my-package-container-notiphonex {
  margin-top: 20px;
  height: calc(100% - 20px);
}
.notrem-my-package-container-iphonex {
  margin-top: 40px;
  height: calc(100% - 40px);
}
</style>
